import { assignIdsToStruc } from '../../../../../utils/helper';
import { TreeStructureAntrag } from './antrag/TreeStructureAntrag';

export const FoerderAntragStruktur = (application: any, printMode: boolean = false) => {
	let formStruc = TreeStructureAntrag(application, printMode);
	return assignIdsToStruc(formStruc);
};
